export enum MatchingType {
	ById = 1,
	ByReference = 2,
	ByAmount = 3,
	ByHand = 4,
	ByPaidInvoice = 5,
	NoMatch = 9,
}
